import { showCustomToast } from 'common/components/CustomToast/utils';
import { useMutation } from '@apollo/client';
import React from 'react';

import {
  MessageTravelAuthorizationCreate,
  MessageTravelAuthorizationCreateVariables,
} from './__generated__/MessageTravelAuthorizationCreate';
import { PivotKeys } from 'common/components/MessagesSections';
import {
  CreateMessageData,
  CreateNewMessage,
} from 'common/components/CreateNewMessage';
import { Stack } from '@fluentui/react';
import MESSAGE_TRAVEL_AUTHORIZATION_CREATE from './MessageTravelAuthorizationCreate.graphql';
import TRAVEL_AUTHORIZATION from '../../../../TravelAuthorization.graphql';
interface NewMessageProps {
  travelAuthorizationId: string;
  selectedKey: string;
  onCreateMessage: () => void;
  dirty?: boolean;
}

export const NewMessage: React.FC<NewMessageProps> = ({
  travelAuthorizationId,
  selectedKey,
  onCreateMessage,
  dirty,
}) => {
  const [createMessage, { loading }] = useMutation<
    MessageTravelAuthorizationCreate,
    MessageTravelAuthorizationCreateVariables
  >(MESSAGE_TRAVEL_AUTHORIZATION_CREATE);

  const messageFilter =
    selectedKey === PivotKeys.sent
      ? { _isOutgoingMessage: { equalTo: true } }
      : { _isIncomingMessage: { equalTo: true } };

  const onSubmit = async (formData: CreateMessageData) => {
    const { messageComment, reminderDates, isResponseRequired, receivers } = {
      ...formData,
    };
    const { communicationChannel, department, user } = { ...receivers };
    const { errors } = await createMessage({
      variables: {
        input: {
          entityId: travelAuthorizationId,
          message: { messageComment, reminderDates, isResponseRequired },
          communicationChannel,
          department,
          user,
        },
      },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: TRAVEL_AUTHORIZATION,
          variables: {
            id: travelAuthorizationId,
            first: 10,
            filter: messageFilter,
          },
        },
      ],
    });

    if (!errors) {
      onCreateMessage();
      showCustomToast({
        content: 'Message sent successfully.',
        appearance: 'success',
      });
    } else
      showCustomToast({
        content: `${errors[0].message}`,
        appearance: 'error',
      });
  };

  return (
    <Stack tokens={{ padding: '0px 10px 0px 0px' }}>
      <CreateNewMessage onSubmit={onSubmit} loading={loading} dirty={dirty} />
    </Stack>
  );
};
